/**
 * AccountRepository
 *
 * Define os templates de contexto para eventos do domínio de conta do seller.
 */

const AccountRepository = {
  /**
   * Template para falha ao atualizar dados do seller (PUT /user/:id).
   * @param {{ tipo?: 'user'|'company', hasDocuments?: boolean, hasImage?: boolean }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildUpdateContext(ctx = {}) {
    return {
      tags: { flow: 'account_update', domain: 'account', update_type: ctx.tipo ?? 'unknown' },
      extra: {
        tipo: ctx.tipo,
        has_documents: ctx.hasDocuments ?? false,
        has_image: ctx.hasImage ?? false,
      },
    };
  },

  /**
   * Template para falha ao buscar configurações de conta do seller (GET /user-settings).
   * @param {{ setting?: string }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildSettingsFetchContext(ctx = {}) {
    return {
      tags: { flow: 'account_settings_fetch', domain: 'account' },
      extra: {
        setting: ctx.setting,
      },
    };
  },
};

export default AccountRepository;
